module.exports = __webpack_public_path__ + "static/media/LogoOfficialTransparent.c6f2e3bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogoOfficialTransparent.png
// module id = 905
// module chunks = 0